module.exports = __webpack_public_path__ + "static/img/2010peroid.2715b49.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/2010peroid.jpg
// module id = lHs+
// module chunks = 1